<div class="page-actions">
  @if (availableFilters$ | async; as availableFilters) {
    <dv-filter-area
      class="page-actions__filter-area"
      [availableFilters]="availableFilters | vtFilterPermissions"
      [isFilterPanelOpen]="isFilterAreaOpen"
      [openPanelTooltip]="'OnCall.FilterPanel.Open' | translate"
      [closePanelTooltip]="'Fleet.FilterPanel.Close' | translate"
      [addFilterFn]="addFilterFn"
      (filterAreasVisibilityToggled)="onFilterAreaToggled($event)"
      (activeFilterChanged)="onActiveFilterChanged($event)"></dv-filter-area>
  }
</div>
<dv-vertical-splitter
  [resizableSide]="resizableSide.Left"
  id="on-call-vertical-splitter">
  <div left-side>
    <app-on-call-grid
      #grid
      (gridFiltersCleared)="deselectActiveFilter()"></app-on-call-grid>
  </div>
  <div right-side>
    <app-on-call-map
      (refreshTriggered)="onMapRefreshTriggered()"></app-on-call-map>
  </div>
</dv-vertical-splitter>
